const stopFoulCausedPlayerActions = [
  {
    actions: [
      { action: "sendEvent", value: "new", type: "main" },
      { action: "nextState", value: null, type: "primary" },
      { action: "processInserts", value: "all", type: "inserts" },
    ],
    conditions: [],
  },
];

export const StopFoulCausedPlayer = {
  name: "stop-foul-caused-player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "stopFoul.breakPlayer.select",
  showOn: [{ state: "primary", value: "stop-foul-caused-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: {
    state: "primary",
    value: "stop-foul-drawn-player",
    event: "stop-foul-drawn",
  },
  children: [
    {
      name: "prepare-stop-foul-caused-event",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "stop-foul-drawn", type: "from" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "newEvent", value: null, type: "main" },
            {
              action: "clearData",
              value: ["personId", "flagged", "scores", "success"],
              type: "main",
            },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "saveData", value: "caused", type: "subType" },
            {
              action: "saveData",
              value: [{ option: "stopFoul", value: true }],
              type: "options",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "stop-foul-caused-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: stopFoulCausedPlayerActions,
    },
    {
      name: "confirm-later-stop-foul-caused-player",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "confirmLater",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "saveData", type: "flagged", value: true },
            { action: "clearData", value: ["personId"], type: "main" },
          ],
          conditions: [],
        },
        ...stopFoulCausedPlayerActions,
      ],
    },
  ],
};
